import React, { useEffect, createElement } from 'react';
import { SelfDefenseHero } from './self-defense/SelfDefenseHero';
import { SelfDefenseBenefits } from './self-defense/SelfDefenseBenefits';
import { SelfDefenseWhatYouLearn } from './self-defense/SelfDefenseWhatYouLearn';
import { SelfDefenseReviews } from './self-defense/SelfDefenseReviews';
import { SelfDefenseScheduleLocation } from './self-defense/SelfDefenseScheduleLocation';
import { SelfDefenseFAQHeader } from './self-defense/SelfDefenseFAQHeader';
import { SelfDefenseFAQQuestions } from './self-defense/SelfDefenseFAQQuestions';
import { SelfDefenseRelatedLinks } from './self-defense/SelfDefenseRelatedLinks';
import { SelfDefenseFinalCTA } from './self-defense/SelfDefenseFinalCTA';
export function SelfDefense() {
  useEffect(() => {
    document.title = 'Self-Defense Classes Farmington Hills | Storm Taekwondo';
    const metaDesc = document.querySelector('meta[name="description"]');
    const content = 'Build confidence, awareness and martial arts fundamentals with self-defense-focused Taekwondo classes near Farmington Hills. Free trial available.';
    if (metaDesc) {
      metaDesc.setAttribute('content', content);
    } else {
      const meta = document.createElement('meta');
      meta.name = 'description';
      meta.content = content;
      document.head.appendChild(meta);
    }
  }, []);
  return <div className="flex flex-col bg-off-white" data-id="element-3052">
      <SelfDefenseHero data-id="element-3053" />
      <SelfDefenseBenefits data-id="element-3054" />
      <SelfDefenseWhatYouLearn data-id="element-3055" />
      <SelfDefenseReviews data-id="element-3056" />
      <SelfDefenseScheduleLocation data-id="element-3057" />
      <section className="py-24 bg-paper border-t border-subtle-gray" data-id="element-3058">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3059">
          <SelfDefenseFAQHeader data-id="element-3060" />
          <SelfDefenseFAQQuestions data-id="element-3061" />
        </div>
      </section>
      <SelfDefenseRelatedLinks data-id="element-3062" />
      <SelfDefenseFinalCTA data-id="element-3063" />
    </div>;
}